// MiniParabolaPlane.js
import React from "react";
import CoordinatePlane from "./CoordinatePlane";

/**
 * Approximate a parabola y = a*x^2 + b*x + c
 * by returning many short line segments from xStart..xEnd
 * with step increments. Each segment is drawn in "color".
 */
function approximateParabola(
  a = 1,
  b = 0,
  c = 0,
  xStart = -2,
  xEnd = 6,
  step = 0.2,
  color = "gray"
) {
  const segments = [];
  for (let x = xStart; x < xEnd; x += step) {
    const nextX = x + step;
    // compute y at x
    const y1 = a*x*x + b*x + c;
    // compute y at nextX
    const y2 = a*nextX*nextX + b*nextX + c;

    segments.push({
      start: [x, y1],
      end: [nextX, y2],
      color
    });
  }
  return segments;
}

/**
 * MiniParabolaPlane:
 * A small coordinate-plane (300×300) that draws:
 *   y = x^2 - 3x + 4  (in gray, from x ~ -1..6)
 *   y = 2x + 1        (in blue)
 * Axes enabled, plotting disabled.
 */
export default function MiniParabolaPlane() {
  // Approximate the parabola y=x^2 -3x +4
  // We'll show it from x=-1..x=6 for a good view
  const parabolaSegs = approximateParabola(1, -3, 4, -1, 6, 0.2, "gray");

  // The line y=2x+1, let's just draw from x=-2..7
  // so it extends beyond the parabola range
  const lineObj = {
    start: [-2, 2*(-2)+1], // y=2*(-2)+1 => -3
    end:   [7,  2*7+1],    // y=14+1 => 15
    color: "blue",
    label: "y=2x+1"
  };

  return (
    <CoordinatePlane
      width={300}
      height={300}
      showAxes={true}
      disablePlot={true}
      lines={[...parabolaSegs, lineObj]}
    />
  );
}
